export default __webpack_public_path__ + "static/media/FAQ_11_3.91cd865d.png";